import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import Select from "react-select";
import InputError from "./InputError";
import InputTitle from "./InputTitle";
import { Context } from "components/Form";
import { getId } from "helpers/functions";

const ReactSelect = ({
  control: controlOverride,
  errors: errorsOverride,
  name,
  options,
  rules = { required: <FormattedMessage id="requiredField" /> },
  lg = 6,
  filterAgainst = null,
  ...rest
}) => {
  const { locale, formatMessage } = useIntl();
  const dir = locale === "ar" ? true : false;

  const {
    control = controlOverride,
    errors = errorsOverride,
    watch = () => {},
  } = useContext(Context);
  // useEffect(() => {
  //   const formSelectValue = values?.[name]?.id;

  //   setValue(name, formSelectValue);
  // }, [])
  const handleSelectOptions = (options) => {
    if (options?.length < 0) return [];
    return options
      ?.filter(
        (option) =>
          filterAgainst === null ||
          option?.[filterAgainst] ===
            (watch(filterAgainst)?.value || watch(filterAgainst))
      )
      ?.map((option) => {
        return {
          value: getId(option) || option?.value || option,
          label:
            option?.name?.[locale] ||
            option?.label ||
            formatMessage({ id: option }),
        };
      });
  };

  const getSelected = (selected) =>
    typeof selected === "object"
      ? handleSelectOptions(options)?.filter((op) =>
          selected?.includes(op?.value)
        )
      : handleSelectOptions(options)?.find((option) => {
          return option?.value === selected;
        });

  return (
    <>
      <Col lg={lg}>
        <div className={`form-group ${rules?.required ? "required" : ""}`}>
          <InputTitle name={name} />
          <Controller
            control={control}
            render={({ field: { onChange, value, name, ref } }) => {
              return (
                <Select
                  inputRef={ref}
                  value={getSelected(value)}
                  name={name}
                  placeholder={<FormattedMessage id={name} />}
                  options={handleSelectOptions(options)}
                  onChange={(selectedOption) => {
                    onChange(
                      selectedOption?.value ||
                        selectedOption?.map((e) => e?.value)
                    );
                  }}
                  isRtl={dir}
                  isSearchable={false}
                  className="basic-single"
                  classNamePrefix="select"
                  {...rest}
                />
              );
            }}
            name={name}
            rules={rules}
          />

          <InputError name={name} errors={errors} />
        </div>
      </Col>
    </>
  );
};

export default ReactSelect;
